import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouteLocations } from '../../common/routing/route-locations.enum';
import { GameEntityType, GameEntityTypeDetails } from '../../../../../common/dto/game-entities.dto';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgOptimizedImage } from '@angular/common';
import {
  GameEntityTypeIconComponent
} from '../../common/components/game-entity-type-icon/game-entity-type-icon.component';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, FaIconComponent, NgOptimizedImage, GameEntityTypeIconComponent],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavbarComponent {
  @Input({ required: true })
  public align!: 'left' | 'center';

  protected getQueryParamsForType(type: GameEntityType) {
    return {
      [RouteLocations.Dashboard.children.GameEntities.children.GameEntityList.queryParams.gameEntityType]: type,
    };
  }

  protected readonly RouteLocations = RouteLocations;
  protected readonly GameEntityType = GameEntityType;
  protected readonly GameEntityTypeDetails = Object.values(GameEntityTypeDetails);
}
